import { StoryblokComponent } from '@storyblok/react';

import { Button } from '../../../components/Button/Button';
import { patchedStoryblokEditable } from '../../../utils/patchedStoryblokEditable';
import { useFormBuilderContext } from '../hooks/useFormBuilderContext';
import { FormBuilderSubmitButtonWrapper } from './FormBuilderSubmitButton.styles';
import { FormBuilderSubmitButtonProps } from './FormBuilderSubmitButton.types';

export const FormBuilderSubmitButton = (props: FormBuilderSubmitButtonProps) => {
  const { blok } = props;
  const { fullWidth } = blok;

  const { hookForm } = useFormBuilderContext();

  const button = blok.button.length ? blok.button[0] : null;

  if (!button) {
    return null;
  }

  if (button.component === 'button') {
    return (
      <FormBuilderSubmitButtonWrapper {...patchedStoryblokEditable(blok)} fullWidth={fullWidth}>
        <Button
          text={button.buttonText}
          variant={button.buttonVariant}
          disabled={!hookForm.formState.isValid}
          type="submit"
          fullWidth={fullWidth}
          shrink
        />
      </FormBuilderSubmitButtonWrapper>
    );
  }

  if (button.component === 'cta') {
    return (
      <FormBuilderSubmitButtonWrapper {...patchedStoryblokEditable(blok)} fullWidth={fullWidth}>
        <StoryblokComponent blok={button} disabled={!hookForm.formState.isValid} type="submit" />
      </FormBuilderSubmitButtonWrapper>
    );
  }

  return null;
};
